import { render } from "./SportEntities.vue?vue&type=template&id=16812767"
import script from "./SportEntities.vue?vue&type=script&lang=js"
export * from "./SportEntities.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__